import { Component, OnInit, Output, EventEmitter, forwardRef } from '@angular/core';
import { 
    ToastController
} from '@ionic/angular/standalone';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { DemoozDateToStringPipe } from '@demooz/pipes';
import { DemoozButtonComponent, DemoozInputComponent } from '@demooz/components';
import { MatchService, AmbassadorService } from '@app/services';

@Component({
    selector: 'app-demonstrations-validation-code',
    templateUrl: './validation-code.component.html',
    styleUrls: ['./validation-code.component.scss'],
    imports: [
        TranslatePipe, DemoozDateToStringPipe, ReactiveFormsModule, 
        forwardRef(() => DemoozButtonComponent), forwardRef(() => DemoozInputComponent)
    ]
})
export class DemonstrationsValidationCodeComponent  implements OnInit {
      
    @Output() onValidationCode = new EventEmitter<boolean>();
    
    isFetchingValidate: boolean= false;
    validationCodeForm: FormGroup = new FormGroup({
        code: new FormControl(null, Validators.required),       
    });
      
    constructor(             
        public translateService: TranslateService,
        private toastController: ToastController,
        public matchService: MatchService,
        public ambassadorService: AmbassadorService
    ) { }

    ngOnInit() {
        
    }
    
    async validateByCode() {
        if(this.validationCodeForm.valid){   
            this.isFetchingValidate = true;
            let status = await this.matchService.validateMatchByCode(this.validationCodeForm.controls['code'].value);            
            if(status){
                await this.ambassadorService.refreshAmbassador();
                const toast = await this.toastController.create({
                    message: this.translateService.instant('DEMONSTRATIONS_VALIDATION_CODE.MSG_SUCCESS_VALIDATE_MATCH'),
                    duration: 6000,
                    position: 'top',
                    color: 'success'
                });
                await toast.present();     
                this.validationCodeForm.reset();   
                this.onValidationCode.emit(true);
            }
            else{               
                const toast = await this.toastController.create({
                    message: this.translateService.instant('DEMONSTRATIONS_VALIDATION_CODE.MSG_ERROR_VALIDATE_MATCH'),
                    duration: 6000,
                    position: 'top',
                    color: 'danger'
                });
                await toast.present();
            }
            this.isFetchingValidate = false;
        }
        else{
            for (var controlName in this.validationCodeForm.controls) {
                if(!this.validationCodeForm.controls[controlName].valid) {
                    this.validationCodeForm.controls[controlName].markAsTouched();
                }
            }
        }
    }
    
}
